import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { authActions } from 'src/auth';
import Button from 'src/views/components/button';
import ReactiveSearch from 'src/views/components/reactive-search';
import CTA from 'src/views/components/cta';
import Footer from 'src/views/components/footer';
import LibraryHero from 'src/views/components/library-hero';
import SignUpForm from 'src/views/components/signup-form';

export class Resources extends Component {
  
    componentWillMount() {

    }
  
    render() {
      return (
        <div className="g-row">

        <ReactiveSearch />

        <div>
        <div className="cta cta--reverse">
          <div className="container">
            <div className="cta__inner">
              <h2 className="cta__title" style={{fontWeight:'600', color:'#fff'}}>Don't miss anything new</h2>
              <p className="cta__sub cta__sub--center">Get the latest language learning tips, apps and books in our newsletter:</p>
              	<div className="container">
					<div className="hero__content__inner" id='navConverter' style={{margin:'0 auto'}}>
              <SignUpForm message="Sign up for free" positionTop="0px" positionRight="0px" />
              </div></div>
            </div>
          </div>
        </div>
      </div>
  
        <Footer/>
      </div>
      );
    }
  }
  
  export default Resources;
  


// WEBPACK FOOTER //
// ./src/views/pages/resources/resources.js